import * as React from 'react';
import * as navigate from 'app/area/shared/navigation';
import { DisplayLink } from 'ui';
import { useLocation } from 'react-router-dom';
import { isCaseViewModalOpen, shouldOpenCaseInModal } from 'app/components/helpers';

interface FactLinkProps {
  classNames?: string;
  section?: number;
  url?: string;
  children?: React.ReactNode;
  id?: string;
  urlOpenNew?: boolean;
  urlHrefNewTabOverride?: string;
  params?: { [key: string]: any };
}

export const FactLink: React.FC<FactLinkProps> = ({ id, classNames = '', section, children, 
  url, urlOpenNew, urlHrefNewTabOverride, params }) => {
  const className = `${classNames} fact-link`;
  const {search} = useLocation();
  const resolvedUrl = shouldOpenCaseInModal(!params?.id) || isCaseViewModalOpen() ? `${url}${search}` : url;
  const linkTo = section || url ? navigate.toSectionURL(section, resolvedUrl) : undefined;

  return (
    <DisplayLink componentId={id} className={className} url={linkTo} urlOpenNew={urlOpenNew} section={section} 
      navigateToUrlForNewTab={!!url} urlHrefNewTabOverride={urlHrefNewTabOverride}>
      {children}
    </DisplayLink>
  );
};
